import { FC, useRef, useState } from "react"
import { isMobileOrTablet } from "src/helpers";
import { useOnClickOutside } from "src/hooks/useClickOutside";


const ActionDashboardTitle: FC = (): JSX.Element => {
  const [infoIconIndex, changeInfoIconIndex] = useState<number>(-1);
  const toggleIconRef = useRef<HTMLElement | null>(null);

  useOnClickOutside(toggleIconRef, () => {
    changeInfoIconIndex(-1);
  });

  const handleIconClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();
    changeInfoIconIndex(infoIconIndex !== 4 ? 4 : -1);
  };

  return (
      <span>
          Action Dashboard
          {isMobileOrTablet() ? (
              <i ref={toggleIconRef} className="bi bi-question-circle-fill info-icon ms-2" onClick={handleIconClick}>
                  <span
                      className={`info-icon-detail bg-dark ${infoIconIndex > 0 ? "d-block" : "d-none"}`}
                      dangerouslySetInnerHTML={{
                          __html: `<p class="m-0 text-start">This dashboard only displays your patients with open/active cases: a treatment decision has not been determined yet. Designed to make case management easier for your practice. Includes detailed updates on your Specialty Pharmacy cases.</p>`
                      }}
                  ></span>
              </i>
          ) : (
              <i className="bi bi-question-circle-fill ms-2"
                 title="This dashboard only displays your patients with open/active cases: a treatment decision has not
               been determined yet. Designed to make case management easier for your practice. Includes detailed updates
               on your Specialty Pharmacy cases.">
              </i>
          )}
      </span>
  );
}

export default ActionDashboardTitle
